var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-coupone-send" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            { staticClass: "search-form" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  attrs: { inline: true, model: _vm.searchForm },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放门店名称" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入发放门店名称",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.storeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "storeName", $$v)
                          },
                          expression: "searchForm.storeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放模式" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发放模式",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.issueMode,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "issueMode", $$v)
                            },
                            expression: "searchForm.issueMode",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "单人", value: "SINGLE" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "多人", value: "MULTIPLE" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择状态", clearable: "" },
                          model: {
                            value: _vm.searchForm.issueStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "issueStatus", $$v)
                            },
                            expression: "searchForm.issueStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "待领取", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "部分领取", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已领完", value: "2" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "已失效", value: "3" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发放类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.issueType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "issueType", $$v)
                            },
                            expression: "searchForm.issueType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "常规客诉", value: "0" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "紧急客诉", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          clearable: "",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放门店" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择门店",
                          },
                          model: {
                            value: _vm.searchForm.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "storeId", $$v)
                            },
                            expression: "searchForm.storeId",
                          },
                        },
                        _vm._l(_vm.shoplist, function (group) {
                          return _c(
                            "el-option-group",
                            {
                              key: group.regionId,
                              attrs: { label: group.regionName },
                            },
                            _vm._l(group.dealerList, function (item) {
                              return _c("el-option", {
                                key: item.dealerId,
                                attrs: {
                                  label: item.dealerName,
                                  value: item.dealerId,
                                },
                              })
                            }),
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否跳过登记单" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.searchForm.isRetOrd,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "isRetOrd", $$v)
                            },
                            expression: "searchForm.isRetOrd",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "是", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "否", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.recordList, border: "" },
            },
            [
              _c("el-table-column", { attrs: { prop: "id", label: "发放ID" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issueCode",
                  label: "发放流水号",
                  "min-width": "170",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "storeId", label: "门店ID" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "operatorName", label: "发放人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "issueMode", label: "发放模式" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.issueMode === "SINGLE" ? "单人" : "多人"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "issueNum", label: "发放人数" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "claimNum", label: "领取人数" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "issueStatus", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getIssueStatusType(
                                scope.row.issueStatus
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getIssueStatusText(scope.row.issueStatus)
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issueReason",
                  label: "原因",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issueType",
                  label: "发放类型",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.issueType === 0
                                ? "常规客诉"
                                : "紧急客诉"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "relatedOrderNo",
                  label: "关联单号",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuedAt",
                  label: "发放时间",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.issuedAt)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isRet",
                  label: "是否跳过登记单",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.isRet === true ? "是" : "否") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderPic",
                  label: "订单图片",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.orderPic === null ||
                        row.orderPic === "" ||
                        row.orderPic === undefined
                          ? _c("span", [
                              _vm._v("\n          未上传图片\n        "),
                            ])
                          : _c("el-image", {
                              staticStyle: { width: "80px", height: "40px" },
                              attrs: {
                                src: row.orderPic,
                                fit: "contain",
                                "preview-src-list": [row.orderPic],
                                "preview-teleported": "",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.couponInfo(scope.row)
                              },
                            },
                          },
                          [_vm._v("券信息")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.couponReceiveLog(scope.row)
                              },
                            },
                          },
                          [_vm._v("券领取记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.searchForm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "券发放记录",
            visible: _vm.couponSendLogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.couponSendLogVisible = $event
            },
            close: function ($event) {
              _vm.couponSendLogVisible = false
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingLog,
                  expression: "loadingLog",
                },
              ],
              attrs: { data: _vm.couponSendLogList, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "issueCode",
                  label: "发放流水号",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponId",
                  label: "系统内优惠券ID",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponName",
                  label: "券名称",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "couponNum",
                  label: "优惠券数量(x张/每人)",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "allCouponNum",
                  label: "优惠券总数",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "issuedAt",
                  label: "发放时间",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.issuedAt)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.couponInfoLogFrom.page,
                  "page-sizes": [10, 20, 50],
                  "page-size": _vm.couponInfoLogFrom.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.couponInfoLogFrom.total,
                },
                on: {
                  "size-change": _vm.handleLogSizeChange,
                  "current-change": _vm.handleLogCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }